module.exports = __webpack_public_path__ + "img/Monte_Kope_56.993b72ae.jpg";